module.exports = __webpack_public_path__ + "static/media/lead-email.06e0e983.png";